export function click(definition, absolutePoint) {
  //check hit to selected itemView
  if (definition.hitDetection(absolutePoint)) {
    //user's callback
    definition.onClick()

    //stop checking of interations
    return true
  }

  return false
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseDown/click.js